export function getApplicationDefaultValues(formType){
    var defaults = null
    switch(formType){
        case "resume":
            defaults = {
                application_details: {name: "", tags: ""},
                experiences: [],
                education: [],
                projects: [],
                additional_links: [],
                references: [],
                skills: {skills: ""},
                contact_information: {name: "", email: "", phone_number: "", location: ""}
            }
            break
        case "college":
            defaults = {
                application_details: {name: "", tags: ""},
            }
            break
        default:
            defaults = {}
            break
    }
    return defaults
}